import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";
import {
  CANCEL_BOOKING,
  CREATE_BOOKING,
  GET_BOOKING_LIST,
  GET_USERS_URL,
} from "../../services/urls";
import { getPharmacyId } from "../../utils/commonFunctions";

// Initial state
const initialState = {
  loading: false,
  bookingLoading: false,
  labTestBookings: [],
  usersList: [],
  usersListLoading: false,
  error: null,
};

// Async thunk to fetch pharmacy lab tests (existing)
export const fetchLabTestBooking = createAsyncThunk(
  "labTests/fetchLabTestBooking",
  async (
    { date = "", status = "open", limit = 10, page = 1, search = "" },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.get(
        GET_BOOKING_LIST.replace(":pharmacyId", getPharmacyId()),
        {
          params: { date, status, limit, page, search },
        }
      );
      return response.data?.data?.bookings; // Return the pharmacy lab test data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch pharmacy lab tests"
      );
    }
  }
);

// Async thunk to fetch pharmacy lab tests (existing)
export const fetchUsersWithNameOrEmail = createAsyncThunk(
  "labTests/fetchUsersWithNameOrEmail",
  async (search = "", { rejectWithValue }) => {
    try {
      const response = await api.post(GET_USERS_URL, {
        query: encodeURI(search),
      });
      return response.data.data; // Return the pharmacy lab test data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch pharmacy lab tests"
      );
    }
  }
);

// Async thunk to cancel a users lab tests
export const cancelBooking = createAsyncThunk(
  "labTestBooking/cancelBooking",
  async ({ bookingId, userId }, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        CANCEL_BOOKING + `/${bookingId}/${userId}`
      );
      return response.data.data; // Assuming your API response contains the new team data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to cancel the booking"
      );
    }
  }
);

// Async thunk to cancel a users lab tests
export const updateBookingStatus = createAsyncThunk(
  "labTestBooking/updateBookingStatus",
  async ({ bookingId, userId, status, barcode }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        CANCEL_BOOKING + `/${bookingId}/${userId}/${getPharmacyId()}`,
        {
          status,
          barcode,
        }
      );
      return response.data.data; // Assuming your API response contains the new team data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update the status"
      );
    }
  }
);

// Async thunk to fetch pharmacy lab tests (existing)
export const createBookingAction = createAsyncThunk(
  "labTestBooking/createBookingAction",
  async (bookingData, { rejectWithValue }) => {
    try {
      const response = await api.post(CREATE_BOOKING, bookingData);
      return response.data.data; // Return the pharmacy lab test data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch pharmacy lab tests"
      );
    }
  }
);

const labTestBookingSlice = createSlice({
  name: "labTestBooking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabTestBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLabTestBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.labTestBookings = action.payload;
      })
      .addCase(fetchLabTestBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUsersWithNameOrEmail.pending, (state) => {
        state.usersListLoading = true;
      })
      .addCase(fetchUsersWithNameOrEmail.fulfilled, (state, action) => {
        state.usersListLoading = false;
        state.error = null;
        state.usersList = action.payload;
      })
      .addCase(fetchUsersWithNameOrEmail.rejected, (state, action) => {
        state.usersListLoading = false;
        state.error = action.payload;
      })
      .addCase(createBookingAction.pending, (state) => {
        state.bookingLoading = true;
      })
      .addCase(createBookingAction.fulfilled, (state, action) => {
        state.bookingLoading = false;
        state.error = null;
      })
      .addCase(createBookingAction.rejected, (state, action) => {
        state.bookingLoading = false;
        state.error = action.payload;
      });
  },
});
export default labTestBookingSlice.reducer;
